import React from "react";

export default function HRCopilotOnboardingHero() {
  return (
    <div className="hrcopilot-hero-wrapper">
      <style>{`
        /* ==============================
           HERO SECTION + BACKGROUND
        ===============================*/
        .hrcopilot-hero-wrapper {
          max-width: 1300px;
          margin: 0 auto;
          padding: 80px 20px;
          margin-top: 40px;
          margin-bottom: 80px;
          position: relative;
          overflow: hidden;

          /* Background Images */
          background-image: 
            url("https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/bgn-map.png"),
            url("https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/bgn-lines.png");
          background-repeat: no-repeat, no-repeat;
          background-position: left -120px top -20px, center top;
          background-size: 260px, cover;
        }

        /* ==============================
           TITLE SECTION
        ===============================*/
        .hrcopilot-headline-container {
          text-align: center;
          margin-bottom: 60px;
        }

        .hrcopilot-main-title {
          font-size: 56px;
          font-weight: 800;
          margin-bottom: 24px;
          color: #1a1a1a;
          font-family: "Raleway", sans-serif;
          line-height: 1.2;
        }

        .hrcopilot-underline-easily {
          color: #c62828;
          position: relative;
        }
        
        .hrcopilot-underline-talent {
          color: #1a1a1a;
        }

        .hrcopilot-subtitle-text {
          font-size: 18px;
          color: #666;
          line-height: 1.6;
          max-width: 700px;
          margin: 0 auto;
        }

        /* ==============================
           CTA BUTTONS
        ===============================*/
        .hrcopilot-cta-section {
          display: flex;
          justify-content: center;
          gap: 18px;
          margin-top: 35px;
        }

        .hrcopilot-btn-primary {
          background: #c62828;
          padding: 16px 38px;
          border-radius: 50px;
          border: none;
          color: white;
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(198, 40, 40, 0.3);
        }

        .hrcopilot-btn-primary:hover {
          background: #a82222;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(198, 40, 40, 0.4);
        }

        .hrcopilot-btn-secondary {
          padding: 14px 38px;
          border-radius: 50px;
          border: 2px solid #c62828;
          background: transparent;
          color: #c62828;
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .hrcopilot-btn-secondary:hover {
          background: #c62828;
          color: white;
          transform: translateY(-2px);
        }

        /* ==============================
           THREE IMAGE FEATURE CARDS
        ===============================*/
        .feature-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
          margin-top: 80px;
        }

        .feature-card {
          background: #fff;
          border-radius: 0;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          position: relative;
        }

        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.12);
        }

        .feature-img-container {
          position: relative;
          width: 100%;
          height: 240px;
          overflow: hidden;
          background: #f8f8f8;
        }

        .feature-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .feature-card:hover .feature-img {
          transform: scale(1.05);
        }

        .feature-content {
          padding: 28px 25px 32px;
          background: white;
        }

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #c62828;
          font-family: "Raleway", sans-serif;
        }

        .feature-sub {
          color: #666;
          font-size: 15px;
          line-height: 1.7;
        }

        .feature-number {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 50px;
          height: 50px;
          background: #c62828;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          box-shadow: 0 3px 10px rgba(198, 40, 40, 0.3);
          z-index: 5;
        }

        /* ==============================
           RESPONSIVE
        ===============================*/
        @media (max-width: 992px) {
          .hrcopilot-main-title {
            font-size: 42px;
          }

          .feature-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .hrcopilot-cta-section {
            flex-direction: column;
            align-items: center;
          }

          .hrcopilot-btn-primary,
          .hrcopilot-btn-secondary {
            width: 100%;
            max-width: 300px;
          }
        }

        @media (max-width: 640px) {
          .hrcopilot-main-title {
            font-size: 36px;
          }
          
          .hrcopilot-subtitle-text {
            font-size: 16px;
          }
        }

      `}</style>

      {/* ==============================
          HERO TITLE
      =============================== */}
      <div className="hrcopilot-headline-container">
        <h1 className="hrcopilot-main-title">
          <span className="hrcopilot-underline-easily">Easily</span> find great{" "}
          <span className="hrcopilot-underline-talent">talent</span> onboard them faster.
        </h1>

        <p className="hrcopilot-subtitle-text">
          HR Copilot automates your entire hiring workflow — helping you recruit smarter,
          onboard faster, and scale confidently.
        </p>

        <div className="hrcopilot-cta-section">
          <button className="hrcopilot-btn-primary">Start now — It's free</button>
          <button className="hrcopilot-btn-secondary">Meet an advisor ▾</button>
        </div>
      </div>

      {/* ==============================
          THREE FEATURE CARDS
      =============================== */}
      <div className="feature-grid">

        <div className="feature-card">
          <div className="feature-img-container">
            {/* <span className="feature-number">1</span> */}
            <img src="/images/onhe1.png" className="feature-img" alt="AI-Powered Onboarding" />
          </div>
          <div className="feature-content">
            <h2 className="feature-title">AI-Powered Onboarding</h2>
            <p className="feature-sub">
              Streamline hiring campaigns with intelligent automation and personalized workflows.
            </p>
          </div>
        </div>

        <div className="feature-card">
          <div className="feature-img-container">
            {/* <span className="feature-number">2</span> */}
            <img src="/images/onhe1.png" className="feature-img" alt="Smart Matching & Outreach" />
          </div>
          <div className="feature-content">
            <h2 className="feature-title">Smart Matching</h2>
            <p className="feature-sub">
              Connect with top talent using predictive algorithms and data-driven insights.
            </p>
          </div>
        </div>

        <div className="feature-card">
          <div className="feature-img-container">
            {/* <span className="feature-number">3</span> */}
            <img src="/images/onhe1.png" className="feature-img" alt="Performance Tracking" />
          </div>
          <div className="feature-content">
            <h2 className="feature-title">Performance Tracking</h2>
            <p className="feature-sub">
              Measure hiring efficiency and improve decision-making with real-time analytics.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}